<template>
  <div class="stock-container">
    <label class="label-quantite">{{$_('quantity')}}</label>
    <div class="quantite-container">
      <NumberField @update-value="quantity = $event" :val="quantity" />
    </div>
    <span class="libelle-stock" :class="{stock: pokstk === 1, reappro: pokstk === 2, contact: pokstk === 3, error: pokstk === -1}">{{stock_info}}</span>
  </div>
</template>

<script>

import productService from "@/modules/produit/services/productService";

import NumberField from '@/common/components/widget/NumberField/NumberField';

export default {
  name: 'ProductStock',
  data() {
    return {
      pokstk: 0,
      pstk: 0,
      punit_stk: '',
      quantity: 1, 
      restocking: Object,
      stock_info: '',
      pfds: 0
    }
  },
  props: ['reset_qte'],
  components: {
    NumberField,
  },
  computed: {
    getLaunchStock() {
      return this.$store.getters['produit/get_launch_stock'];
    },
    getQuantity() {
      return this.quantity;
    }
  },
  created() {
    this.getStockInfo();
  },
  methods: {
    getStockInfo() {

      this.$store.dispatch('produit/SELECT', {key: 'fqte', value: this.quantity});
      this.$store.dispatch('produit/LAUNCH_PRICE');

      productService.getStockInfo({
        pmod: this.$store.getters['produit/get_fmod']  !== '' ? this.$store.getters['produit/get_fmod'] : null,
        ptail1: this.$store.getters['produit/get_ftail1']  !== '' ? this.$store.getters['produit/get_ftail1'] : null,
        ptail2: this.$store.getters['produit/get_ftail2']  !== '' ? this.$store.getters['produit/get_ftail2'] : null,
        popt: this.$store.getters['produit/get_fopt']  !== '' ? this.$store.getters['produit/get_fopt'] : null,
        pcol: this.$store.getters['produit/get_fcol']  !== '' ? this.$store.getters['produit/get_fcol'] : null,
        pmarq: this.$store.getters['produit/get_fmarq']  !== '' ? this.$store.getters['produit/get_fmarq'] : null,
        pqte: this.quantity

      }).then(res => {
        
        if (res.data !== undefined) {

          if(res.data.PFDS === 1 && (this.quantity > res.data.PPOT)) {
            this.$store.dispatch('produit/SET', {key: 'display_button_add_to_cart', value: false});
          } else {
            this.$store.dispatch('produit/SET', {key: 'display_button_add_to_cart', value: true});
          }

          this.pokstk = res.data.POKSTK;
          this.pstk = res.data.PSTK;
          this.punit_stk = res.data.PUNIT_STK;
          this.pfds = res.data.PFDS;

          if(res.data.PPOT !== undefined) {
            this.ppot = res.data.PPOT;
          }

          if (res.data.DS_O !== undefined) this.restocking = res.data.DS_O.OUT[0];

          if(this.$store.getters['produit/get_ftail1'] === '' ||
            this.$store.getters['produit/get_ftail2'] === '' ||
            this.$store.getters['produit/get_opt'] === '' ||
            this.$store.getters['produit/get_fcol'] === '' ||
            this.$store.getters['produit/get_fmarq'] === ''
          ) {
            this.pokstk = -1;
          }

          this.setDisplayStockInfo();

          this.$store.dispatch('produit/SELECT', {key: 'stock_availibility', value: res.data.POKSTK});
          this.$store.dispatch('produit/SELECT', {key: 'launch_stock', value: false});
        }
      }).catch(err => {
        console.error(err);
      });
    },
    setDisplayStockInfo() {

      if(this.pfds === 1) {

        if(this.quantity > this.ppot) {
          this.stock_info = this.$_('potential_excedeed')+' ('+parseInt(this.ppot)+' '+this.$_('pieces')+')';
        } else {
          this.pokstk = 1;
          this.stock_info = this.$_('in_stock');
        }

      } else {


        switch (this.pokstk) {
          case 1:
            this.stock_info = this.$_('in_stock');
            break;
          case 2:
            this.stock_info = this.$_('out_of_stock');
            break;
          case 3:
            this.stock_info = this.$_('out_of_stock_contact_us')+' ('+this.pstk+' '+this.$_('available')+')';
            break;
          default:
            this.stock_info = this.$_('complete_all_fields')
            break;
        }
      }

      if(this.pokstk === 2 || this.pokstk === 3) {
        if(this.restocking !== undefined) {
          this.stock_info += ' ('+this.pstk+this.punit_stk+' '+this.$_('in_stock_and')+' '+this.restocking.TSTKDISP+this.punit_stk+' '+this.$_('on_the')+' '+this.restocking.TDATEDISP+')';
        }
      } else {
        if(this.restocking !== undefined && this.restocking.TDATEDISP !== undefined) {
          this.stock_info += ' ('+this.pstk+this.punit_stk+' '+this.$_('in_stock_and')+' '+this.restocking.TSTKDISP+this.punit_stk+' '+this.$_('on_the')+' '+this.restocking.TDATEDISP+')';
        } else {
          this.stock_info += ' ('+this.pstk+this.punit_stk+' '+this.$_('in_stock')+')';
        }
      } 
    }
  },
  watch: {
    getLaunchStock(val) {
      if(val) {
        this.getStockInfo();
      }
    },
    getQuantity() {
      this.getStockInfo();
    },
    reset_qte(val) {
      if(val === true){
        this.quantity = 1;
      }
    }
  }
};
</script>

<style scoped>
.stock-container {
  padding: 15px;
}
.libelle-stock {
  display: flex;
  align-items: center;
  font-size: var(--fz-md);
}
.libelle-stock.stock:before {
  content: '';
  display: inline-block;
  width: 10px;
  height: 10px;
  background-color: #8BC133;
  border-radius: 50%;
  margin-right: 5px;
}
.libelle-stock.reappro:before {
  content: '';
  display: inline-block;
  width: 10px;
  height: 10px;
  background-color: orange;
  border-radius: 50%;
  margin-right: 5px;
}
.libelle-stock.contact:before {
  content: '';
  display: inline-block;
  width: 10px;
  height: 10px;
  background-color: red;
  border-radius: 50%;
  margin-right: 5px;
}
.libelle-stock.stock {
  color: #8BC133;
}
.libelle-stock.reappro {
  color: orange;
}
.libelle-stock.contact {
  color: red;
}
.libelle-stock.error {
  color: red;
}
/deep/
.number-field {
  margin: 10px 0;
}
</style>